export enum CasesDetailsTab {
  INFO = 'info',
  NOTES = 'notes',
  RESOLUTION = 'resolution',
  SEARCHES = 'searches',
}
